import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Slider = ({ slides }) => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        if (slides.length === 0) return;
        
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 7000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    if (!slides || slides.length === 0) {
        return (
            <div className="relative h-screen bg-gradient-to-br from-red-900 via-red-800 to-red-900">
                <div className="absolute inset-0 bg-black/20"></div>
                <div className="relative h-full flex items-center">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-12">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
                            <div className="text-white space-y-6 lg:space-y-8">
                                <div className="space-y-4">
                                    <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold rounded-full">
                                        Professional Solutions
                                    </div>
                                    <h1 className="text-3xl sm:text-4xl lg:text-7xl font-bold leading-tight tracking-tight">
                                        Bruce Tank
                                    </h1>
                                    <div className="w-24 h-1 bg-white rounded-full"></div>
                                </div>
                                <p className="text-lg sm:text-xl lg:text-2xl text-red-100 leading-relaxed max-w-2xl">
                                    Yuqori sifatli va ishonchli mahsulotlar bilan B2B va B2C mijozlarimizga professional xizmat ko'rsatamiz
                                </p>
                                <div className="flex flex-col sm:flex-row flex-wrap gap-4 pt-6">
                                    <Link 
                                        to="/products"
                                        className="group inline-flex items-center bg-white text-red-800 hover:bg-red-50 px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl"
                                    >
                                        <span className="mr-2">Mahsulotlar</span>
                                        <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                        </svg>
                                    </Link>
                                    <Link 
                                        to="/about"
                                        className="group inline-flex items-center border-2 border-red-200 text-white hover:bg-white hover:text-red-900 px-8 py-4 rounded-lg font-semibold transition-all duration-300"
                                    >
                                        <span className="mr-2">Biz Haqimizda</span>
                                        <svg className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                            <div className="hidden sm:block lg:block">
                                <div className="relative">
                                    <div className="w-full h-72 sm:h-96 bg-white rounded-2xl border border-red-700 flex items-center justify-center">
                                        <div className="text-red-200 text-center space-y-4">
                                            <div className="w-20 h-20 bg-red-600 rounded-2xl flex items-center justify-center mx-auto">
                                                <svg className="w-10 h-10 text-red-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                            </div>
                                            <p className="text-lg font-medium">Slider rasmlarini admin panelden yuklang</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="relative min-h-screen overflow-hidden bg-red-900">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M30 30c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                }}></div>
            </div>

            {/* Slider Content */}
            <div 
                className="flex transition-transform duration-1000 ease-in-out h-full"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
                {slides.map((slide, index) => (
                    <div key={slide.id} className="w-full h-full flex-shrink-0 relative">
                        {/* Clean Gradient Background */}
                        <div className="absolute inset-0 bg-gradient-to-br from-red-900 via-red-800 to-red-900"></div>
                        
                        {/* Content Container */}
                        <div className="relative min-h-screen flex items-center z-10 py-8 sm:py-12">
                            <div className="container mx-auto px-4 sm:px-6 lg:px-12">
                                <div className="flex flex-col lg:grid lg:grid-cols-2 gap-6 lg:gap-16 items-center">
                                    {/* Mobile/Tablet Product Image - Show at top */}
                                    <div className="block lg:hidden w-full order-1">
                                        <div className="relative mx-4">
                                            {/* Product Image Container */}
                                            <div className="relative bg-white rounded-2xl p-3 sm:p-4 border border-white/10 shadow-xl">
                                                <div className="relative">
                                                    <img
                                                        src={slide.image}
                                                        alt={slide.title}
                                                        className="w-full h-48 sm:h-64 object-cover rounded-xl shadow-lg"
                                                    />
                                                    {/* Image Enhancement Overlay */}
                                                    <div className="absolute inset-0 bg-gradient-to-t from-red-900/20 via-transparent to-transparent rounded-xl"></div>
                                                    
                                                    {/* Floating Badge */}
                                                    <div className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white/90 backdrop-blur-sm text-red-800 px-2 sm:px-3 py-1 sm:py-1.5 rounded-full text-xs sm:text-sm font-semibold border border-white/50">
                                                        Premium Quality
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Content - Mobile/Tablet below image, Desktop left side */}
                                    <div className="text-white space-y-4 sm:space-y-6 lg:space-y-8 order-2 lg:order-1">
                                        <div className="space-y-3 sm:space-y-4 lg:space-y-6 text-center lg:text-left">
                                            <div className="inline-block px-4 py-2 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold rounded-full border border-white/30">
                                                Professional Solution
                                            </div>
                                            <h1 className="text-xl sm:text-2xl lg:text-6xl font-bold leading-tight tracking-tight">
                                                {slide.title}
                                            </h1>
                                            <div className="w-16 sm:w-20 h-1 bg-white rounded-full mx-auto lg:mx-0"></div>
                                        </div>
                                        
                                        <p className="text-base sm:text-lg lg:text-2xl text-red-100 leading-relaxed max-w-2xl text-center lg:text-left mx-auto lg:mx-0">
                                            {slide.description}
                                        </p>
                                        
                                        <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 pt-4 sm:pt-6 justify-center lg:justify-start">
                                            <Link 
                                                to="/contact"
                                                className="group inline-flex items-center justify-center bg-white text-red-800 hover:bg-red-50 px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl text-sm sm:text-base"
                                            >
                                                <span className="mr-2">Biz Bilan Bog'lanish</span>
                                                <svg className="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                                                </svg>
                                            </Link>
                                            <Link 
                                                to="/products"
                                                className="group inline-flex items-center justify-center border-2 border-red-200 text-white hover:bg-white hover:text-red-900 px-6 sm:px-8 py-3 sm:py-4 rounded-lg font-semibold transition-all duration-300 text-sm sm:text-base"
                                            >
                                                <span className="mr-2">Mahsulotlar</span>
                                                <svg className="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                                                </svg>
                                            </Link>
                                        </div>
                                        
                                        {/* Business Stats */}
                                        <div className="grid grid-cols-3 gap-2 sm:gap-4 lg:gap-8 pt-4 sm:pt-6 lg:pt-8 border-t border-red-700/50">
                                            <div className="text-center lg:text-left">
                                                <div className="text-base sm:text-xl lg:text-4xl font-bold text-white">1000+</div>
                                                <div className="text-xs sm:text-sm text-red-200 font-medium">Mamnun Mijozlar</div>
                                            </div>
                                            <div className="text-center lg:text-left">
                                                <div className="text-base sm:text-xl lg:text-4xl font-bold text-white">5+</div>
                                                <div className="text-xs sm:text-sm text-red-200 font-medium">Yillik Tajriba</div>
                                            </div>
                                            <div className="text-center lg:text-left">
                                                <div className="text-base sm:text-xl lg:text-4xl font-bold text-white">24/7</div>
                                                <div className="text-xs sm:text-sm text-red-200 font-medium">Texnik Yordam</div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    {/* Desktop Product Image - Right side */}
                                    <div className="hidden lg:block order-3 lg:order-2">
                                        <div className="relative">
                                            {/* Decorative Background Elements */}
                                            <div className="absolute -top-6 -right-6 w-24 h-24 bg-white/20 rounded-full blur-2xl"></div>
                                            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-red-700/30 rounded-full blur-3xl"></div>
                                            
                                            {/* Product Image Container */}
                                            <div className="relative bg-white rounded-3xl p-6 lg:p-8 border border-white/10 shadow-2xl">
                                                <div className="relative">
                                                    <img
                                                        src={slide.image}
                                                        alt={slide.title}
                                                        className="w-full h-80 lg:h-96 object-cover rounded-2xl shadow-xl"
                                                    />
                                                    {/* Image Enhancement Overlay */}
                                                    <div className="absolute inset-0 bg-gradient-to-t from-red-900/20 via-transparent to-transparent rounded-2xl"></div>
                                                    
                                                    {/* Floating Badge */}
                                                    <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm text-red-800 px-3 py-1.5 rounded-full text-sm font-semibold border border-white/50">
                                                        Premium Quality
                                                    </div>
                                                </div>
                                                
                                                {/* Product Info Overlay */}
                                                <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-md rounded-xl p-4 border border-white/20">
                                                    <h3 className="text-red-800 font-semibold text-lg mb-1">{slide.title}</h3>
                                                    <p className="text-red-600 text-sm">Professional Grade Solution</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* Navigation Arrows */}
            {slides.length > 1 && (
                <>
                    <button
                        onClick={prevSlide}
                        className="absolute left-2 sm:left-4 lg:left-6 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white p-2 sm:p-3 rounded-full transition-all duration-300 hover:scale-110 z-30"
                    >
                        <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <button
                        onClick={nextSlide}
                        className="absolute right-2 sm:right-4 lg:right-6 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white p-2 sm:p-3 rounded-full transition-all duration-300 hover:scale-110 z-30"
                    >
                        <svg className="w-4 h-4 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </>
            )}

            {/* Enhanced Dots Indicator */}
            {slides.length > 1 && (
                <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-2 sm:space-x-3 z-30">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => goToSlide(index)}
                            className={`transition-all duration-300 ${
                                index === currentSlide 
                                    ? 'w-8 sm:w-12 h-2 sm:h-3 bg-white rounded-full shadow-lg' 
                                    : 'w-2 sm:w-3 h-2 sm:h-3 bg-white/40 hover:bg-white/60 rounded-full hover:scale-125'
                            }`}
                        />
                    ))}
                </div>
            )}

            {/* Slide Progress Bar */}
            {slides.length > 1 && (
                <div className="absolute bottom-0 left-0 w-full h-1 bg-red-800 z-30">
                    <div 
                        className="h-full bg-gradient-to-r from-white to-red-100 transition-all duration-300"
                        style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
                    ></div>
                </div>
            )}
        </div>
    );
};

export default Slider;
